import React from 'react';

export default (props: any) => {
    return (
        <button {...props} className={`bg-slate-900 text-green-400 p-2 shadow-md shadow-black rounded-lg h-20 font-bold font-SoulGaze ${props.className}`}>
            {props.label}
        </button>
    );
}